import { render, staticRenderFns } from "./ProjectInfoList.vue?vue&type=template&id=0af5d864&"
import script from "./ProjectInfoList.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports